const PARAMETERS: { [key: string]: string | number } = {
    "palette.primary.main": "#D1020A",
    "palette.primary.light": "#FF1B24",
    "palette.primary.dark": "#A30007",
    "palette.primary.contrastText": "#FFFFFF",
    "palette.secondary.main": "#523629",
    "palette.secondary.light": "#745E53",
    "palette.secondary.dark": "#39251C",
    "palette.secondary.contrastText": "#FFFFFF",
    "index.logo.width": 290
}

export default PARAMETERS
